
const HttpMethod = {
  GET : 'GET',
  PUT : 'PUT',
  POST : 'POST',
};

export default HttpMethod;
